import { Component, inject, input } from '@angular/core';
import { IntroStep, TourService } from '../../../core/services/tour.service';

@Component({
  selector: 'wf-page-tour',
  standalone: true,
  template: `
    <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
      <img src="/assets/images/tutorialOverlayBttn.svg" alt="Start Tour"/>
    </button>
  `
})
export class TourComponent {
  private tourService = inject(TourService);
  steps = input<IntroStep[]>([]);

  startTour() {
    if (this.steps().length > 0) {
      this.tourService.startTour(this.steps());
    }
  }
}
